import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
let searchData = {
  ShipName: '',
  PageNumber: 1,
  PageSize: 25,
  isActive: true,
  isInactive: false,
  isAll: false
}

let user = JSON.parse(localStorage.getItem("currentUser"));

export const searchShipMgmt = (item) => {
  let url = `${API.SearchShip}?ShipName=${item.ShipName}&Status=${item.isAll ? false : item.isActive ? true : false}&isAll=${item.isAll}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getSearchShipSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getSearchShipFailure",
          error: "ERROR"
        })
      })
  }
}

export const getShipDetails = (id) => {
  let url = `${API.GetShipDetails}?shipId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getShipDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getShipDetailsFailure",
          error: "ERROR"
        })
      })
  }
}

export const addShip = (data) => {
  let url = `${API.PostShip}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        dispatch({
          type: "postAddShipSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postAddShipFailure",
          error: "ERROR"
        })
      })
  }
}

export const updateShip = (data) => {
  let url = `${API.UpdateShip}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        dispatch(searchShipMgmt(searchData));
        dispatch({
          type: "updateStaffInfoSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        swal("Error!", "Something went wrong. Please try again.", "warning");
        dispatch({
          type: "updateStaffInfoFailure",
          error: "ERROR"
        })
      })
  }
}

